import React, { useState } from "react";
import { toast } from "react-toastify";
import { get } from "lodash";
import ConfirmationModal from "../../../Common/ConfirmationModal";
import { deleteMlQcRuleRange } from "../../../../actions/qc";

export default function RuleDeleteConfirmationRange({
  data,
  onConfirm,
  onCancel,
  objKey = "_id",
}) {
  const [loading, setLoading] = useState(false);

  const id = get(data, objKey);

  /**
   * handles clicking confirm
   */
  const handleOnConfirm = async () => {
    setLoading(true);
    const response = await deleteMlQcRuleRange(id);
    setLoading(false);
    if (response.success) {
      toast.success(response.message || "Customer range deleted successfully");
      if (onConfirm) onConfirm();
    } else {
      toast.error(response.message || "Something went wrong!");
    }
  };

  return (
    <ConfirmationModal
      open
      title="Delete Customer Range"
      bodyComponent={() => (
        <div>
          You are about to delete customer range for
          {" "}
          <strong>{data?.customer_id}</strong>
          {data?.sample_info && (
            <>
              {" "}
              with sample info
              {" "}
              <strong>{data.sample_info}</strong>
            </>
          )}
        </div>
      )}
      okText="Delete"
      cancelText="Cancel"
      onOk={handleOnConfirm}
      onCancel={onCancel}
      loading={loading}
    />
  );
}
